import React from 'react';
import moment from 'moment';
// this is not used directly, but has to be included
// noinspection ES6UnusedImports
import momentDurationFormatSetup from 'moment-duration-format'; // eslint-disable-line no-unused-vars

export function SearchDropdownItem(props) {
  let duration = '';
  if (props.template.duration) {
    duration = moment.duration(props.template.duration).format('hh:mm', { trim: false });
  }
  return (
    <div className="inline-popup-list-item" role="button" tabIndex="0" onClick={() => props.selectTemplate(props.template)}>
      <div className="bullet">
        <span className="inline-popup-bullet bullet-colour-5" />
      </div>
      <div className="text">{props.template.name}</div>
      {duration && <div className="sub-text">{duration}</div>}
    </div>
  );
}

export default SearchDropdownItem;
